<template>

	<div class='bar-item' @contextmenu.prevent @click.right='_Close( $event )'>

		<input type='checkbox' name='debug_bar_flyout_controller' @change='_Clear( $event )'>
		<div class='label'><span v-html='label'></span><span class='counter'>{{ counter ? counter : '' }}</span></div>
		<div class='effect'></div>

		<div class='flyout'>

			<div class='actions'>
				<slot name='actions' />
			</div>

			<slot />

		</div>

	</div>

</template>


<script setup>

	const props = defineProps
	( {
		label:
		{
			type: String,
			default ()
			{
				return "<i class='fa fa-chevron-up' style='font-size:10px;'></i>";
			}
		},
		counter: Number
	} );


	function _Close ( event )
	{
		let input = event.currentTarget.querySelector( '[name="debug_bar_flyout_controller"]' );

		if ( !input )
			return;

		input.checked = false;
	}


	function _Clear ( event )
	{
		document.querySelectorAll( '#debug_bar [name="debug_bar_flyout_controller"]' ).forEach( checkbox =>
		{
			if ( checkbox != event.currentTarget )
				checkbox.checked = false;
		} );
	}

</script>


<style scoped>

	.bar-item
	{
		display: inline-block;
		font-size: 13px;
		position: relative;
	}


	.bar-item .actions
	{
		position: absolute;
		top: -35px;
		right: 0;
		padding: 3px;
		font-size: 12px;
		color: #fff;
		border-radius: 50px;
		background: #000;
	}
	.bar-item .actions:empty
	{
		display: none;
	}


	.bar-item > input
	{
		opacity: 0;
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;
		cursor: pointer;
		z-index: 3;
	}

	.bar-item > input ~ .label
	{
		display: inline-block;
		padding: 3px 8px 6px 8px;
		cursor: pointer;
		color: #fff;
		border-radius: 0 0 5px 5px;
		transition: background 0.3s, color 0.3s;
		position: relative;
		z-index: 2;
	}

	.bar-item > input:hover ~ .label,
	.bar-item > input:active ~ .label
	{
		background: #555;
	}
	.bar-item > input:checked ~ .label
	{
		background: #c40000;
	}


	.bar-item > input ~ .label .counter
	{
		background: #fff;
		color: #000;
		padding: 1px 4px 2px 4px;
		border-radius: 10px;
		font-size: 8px;
		margin-left: 5px;
		position: relative;
		top: -1px;
		font-weight: bold;
	}
	.bar-item > input ~ .label .counter:empty
	{
		display: none;
	}


	.bar-item > input ~ .effect
	{
		background: #555;
		height: 12px;
		width: 12px;
		position: absolute;
		left: 50%;
		top: 0;
		z-index: 1;
		transform-origin: center center;
		transform: translate(-50%, -50%) rotate(45deg);
		box-shadow: 0 0 4px -1px rgba(0,0,0,1);
		transition: opacity 0.3s, visibility 0s 0.3s;
		opacity: 0;
		visibility: hidden;
	}
	.bar-item > input:hover:not(:checked) ~ .effect,
	.bar-item > input:active:not(:checked) ~ .effect
	{
		transition: opacity 0.3s, visibility 0s 0s;
		opacity: 1;
		visibility: visible;
	}


	.bar-item > input ~ .flyout
	{
		position: absolute;
		bottom: 100%;
		border-bottom: 3px solid #c40000;
		border-top: 3px solid #c40000;
		left: 0;
		background: #333;
		/*overflow: hidden;*/
		border-radius: 5px 5px 0 0;
		font-size: 13px;
		color: #fff;
		box-shadow: 0 2px 10px -2px rgba(0,0,0,1);
		min-height: 150px;
		min-width: 250px;
		transition: opacity 0.3s, visibility 0s 0.3s, left 0s 0.3s;
		opacity: 0;
		visibility: hidden;
		left: -5000px;
	}
	.bar-item > input:checked ~ .flyout
	{
		transition: opacity 0.3s, visibility 0s 0s, left 0s 0s;
		visibility: visible;
		opacity: 1;
		left: 0;
	}

</style>